import { BigNumber } from '@ethersproject/bignumber';

export const calculateGasMargin = (value: BigNumber) => {
  return value.mul(120).div(100);
};
